window.FichaCrediarioItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-ficha-crediario-item",
    tagName: "tr",


    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    }
});


window.FichaCrediarioView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-ficha-crediario",
    childView: FichaCrediarioItemView,
    childViewContainer: "#lista-ficha-crediario-container",

    initialize: function(options) {
        this.app = options.app;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },
});